import React from 'react';
import { GradientCta } from './GradientCta';
import { MediaSlot } from './MediaSlot';
import { checkoutUrl, listPrice, salePrice } from '../../data/config';
import { offerMockup } from '../../data/media';
const offerItems = [{
  emoji: '🎨',
  name: 'Művészetterápiás Kézikönyv — 150+ vezetett tevékenység',
  value: '9 990 Ft'
}, {
  emoji: '🖼️',
  name: '17 kreatív tevékenység az érzelmek kifejezésére',
  value: '2 990 Ft'
}, {
  emoji: '💜',
  name: '20 technika az önbecsülés erősítéséhez',
  value: '2 490 Ft'
}, {
  emoji: '🃏',
  name: 'Félelemoldó kártyák',
  value: '2 490 Ft'
}, {
  emoji: '🔓',
  name: 'Terápiás elakadások feloldása',
  value: '2 990 Ft'
}, {
  emoji: '📘',
  name: 'Alkalmazási és értelmezési útmutató',
  value: '2 490 Ft'
}, {
  emoji: '✨',
  name: '60 kártya a bátorságért és az önbizalomért',
  value: '2 990 Ft'
}, {
  emoji: '🆕',
  name: '✨ Extra ajándék: 100 további művészetterápiás tevékenység',
  value: 'Ingyenes ajándék',
  gift: true
}] as {
  emoji: string;
  name: string;
  value: string;
  gift?: boolean;
}[];
export function PricingOffer() {
  return <section id="ajanlat" aria-labelledby="offer-title" className="scroll-mt-16 bg-gradient-to-b from-lavender-soft to-[#F2E9FB] pb-14 md:pb-20" data-id="element-201" data-mp="2xv4t11q7i0g7">
      <div className="mx-auto max-w-xl px-5" data-id="element-202" data-mp="37six01uy0wrm">
        <div className="rounded-[2rem] bg-white px-5 pb-8 pt-7 shadow-[0_24px_50px_-28px_rgba(140,111,201,0.5)] sm:px-8" data-id="element-203" data-mp="37peo4r6j9cum">
          <div className="text-center" data-id="element-204" data-mp="3grw8f02mnvez">
            <span className="inline-block rounded-full border border-gold-line bg-gold-soft px-6 py-2.5 text-[14px] font-extrabold uppercase tracking-[0.1em] text-gold" data-id="element-205" data-mp="3gquvsr5yr0v5">
              Bevezető ajánlat
            </span>
            <h2 id="offer-title" className="mt-3 font-serif text-[1.65rem] font-semibold leading-tight text-ink [font-style:normal]" data-id="element-206" data-mp="3qh7cg8anq9w0">
              Művészetterápiás Kézikönyv + 6 exkluzív bónusz
            </h2>
          </div>

          <div className="mt-5 overflow-hidden rounded-2xl" data-id="element-207" data-mp="3vh27mo1gtlmv">
            <MediaSlot src={offerMockup} slot="offer-mockup" alt="Művészetterápiás Kézikönyv + 6 exkluzív bónusz" aspect="aspect-square" className="rounded-2xl" data-id="element-208" data-mp="3vimxi0cu4gee" />
          </div>

          <ul className="mt-5 space-y-3" data-id="element-209" data-mp="bf0gnqsrh7kv">
            {offerItems.map(item => <li key={item.name} className="flex items-start gap-3" data-id="element-210" data-mp="gcs8ylxbivpl">
                <span className="w-6 shrink-0 text-center text-[17px] leading-snug" aria-hidden="true" data-id="element-211" data-mp="l3s7fvm35lu7">
                  {item.emoji}
                </span>
                <span className={`min-w-0 flex-1 text-[16px] leading-snug ${item.gift ? 'font-bold text-ink' : 'text-body'}`} data-id="element-212" data-mp="p4u72djwzzwp">
                  {item.name}
                </span>
                {item.gift ? <span className="shrink-0 whitespace-nowrap text-[14px] font-extrabold uppercase leading-snug tracking-[0.02em] text-ok" data-id="element-213" data-mp="z4bf31mn2pvu">
                    {item.value}
                  </span> : <span className="shrink-0 whitespace-nowrap text-[16px] font-bold leading-snug text-body/70 line-through" data-id="element-214" data-mp="35tzpjp7vcm4b">
                    {item.value}
                  </span>}
              </li>)}
          </ul>

          <div className="mt-5 flex items-center justify-between gap-3 border-t border-lavender-line pt-4" data-id="element-215" data-mp="1i73ni2kjpeuq">
            <span className="text-[16px] font-bold text-body" data-id="element-216" data-mp="1e7cpbdsovwg6">Teljes érték:</span>
            <span className="whitespace-nowrap text-[16px] font-bold text-body/70 line-through" data-id="element-217" data-mp="198jdrqwyqfin">26 430 Ft</span>
          </div>

          <div className="mt-6 text-center" data-id="element-218" data-mp="25wy2apofddhm">
            <p className="text-lg font-semibold text-body/70 line-through" data-id="element-219" data-mp="21wf9asasq1du">{listPrice}</p>
            <p className="mt-1 font-display text-6xl font-extrabold tracking-[-0.04em] text-ink" data-id="element-220" data-mp="1wx2ose7ed6ef">{salePrice}</p>
            <p className="mx-auto mt-3 max-w-xs text-[15px] leading-relaxed text-body" data-id="element-221" data-mp="1ryhko3p0y2kp">
              Azonnali hozzáférés · Egyszeri fizetés · 100% digitális
            </p>
          </div>

          <p className="mt-6 rounded-2xl border border-gold-line bg-gold-soft px-5 py-4 text-center text-[16px] font-semibold leading-relaxed text-ink" style={{
          fontWeight: "800"
        }} data-id="element-222" data-mp="gj2p94cgrirp">
            ✨ Extra ajándék: 100 további művészetterápiás tevékenység, ingyen.
          </p>

          <div className="mt-6" data-id="element-223" data-mp="29820sjbvx8e0">
            <GradientCta href={checkoutUrl} checkout data-id="element-224" data-mp="1vfccu9cspte9">
              <span data-id="element-225" data-mp="1vcpv5gw6xxib">Kérem az azonnali hozzáférést&nbsp;→</span>
            </GradientCta>
            <p className="mt-3 text-center text-[14px] leading-relaxed text-body/80" data-id="element-226" data-mp="20e5gla2a6618">
              🔒 Biztonságos fizetés · 🛡️ 30 napos pénzvisszafizetési garancia
            </p>
          </div>
        </div>
      </div>
    </section>;
}